<template>
    <div>
        {{data}}
    </div>
</template>

<script>
    export default {
        name: "test",
        data() {
            return {
                data: "testovaci data",
            }
        },
        created() {
            this.$http.get("http://game.dokamar.cz/authenticated.php", {}, {withCredentials: true}).then(function (xdata) {
                this.data = xdata.body;
            });
        }
    }
</script>

<style scoped>

</style>